import "core-js/modules/es.array.push.js";
import dayjs from "dayjs";
export default {
  name: "plotDialog",
  data() {
    return {
      value1: "",
      value2: "24",
      number: "",
      plotId: "",
      search_data: {
        queryBeginTime: dayjs().subtract(24, "hour").format("YYYY-MM-DD") + " 00:00:00",
        queryEndTime: dayjs().format("YYYY-MM-DD") + " 23:59:59"
      },
      // 实时数据
      lastestData: {},
      timeOptions: [{
        value: "24",
        label: "最近24小时"
      }, {
        value: "3",
        label: "最近3天"
      }, {
        value: "7",
        label: "最近7天"
      }],
      dialogVisible: false,
      chartsOption: {
        // 设置曲线的颜色
        color: ["#19E3B4"],
        grid: {
          top: "20%",
          // 顶部留白
          left: "10%",
          // 左侧留白
          right: "10%",
          // 右侧留白
          bottom: "20%" // 底部留白
        },

        legend: {
          top: 10,
          data: ["温度"],
          textStyle: {
            color: "#fff",
            // 设置文字颜色为白色
            fontSize: 9 // 设置文字大小为7px
          }
        },

        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
        },
        yAxis: {
          type: "value"
        },
        // 设置阴影渐变
        series: [{
          name: "温度",
          type: "line",
          data: [0, 220, 332, 301, 334, 390, 330],
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#19E3B4"
              }, {
                offset: 1,
                color: "rgba(25, 227, 180, 0)"
              }])
            }
          }
        }]
      }
    };
  },
  computed: {
    list() {
      return [{
        icon: require("../../assets/空气温度.png"),
        name: "空气温度",
        value: this.nullFormatter(this.lastestData.airTemperature) + "℃"
      }, {
        icon: require("../../assets/空气湿度.png"),
        name: "空气湿度",
        value: this.nullFormatter(this.lastestData.airHumidity) + "%"
      }, {
        icon: require("../../assets/土壤湿度.png"),
        name: "土壤湿度",
        value: this.nullFormatter(this.lastestData.soilHumidity) + "%"
      }, {
        icon: require("../../assets/土壤温度.png"),
        name: "土壤温度",
        value: this.nullFormatter(this.lastestData.soilTemperature) + "℃"
      }, {
        icon: require("../../assets/二氧化碳.png"),
        name: "二氧化碳",
        value: this.nullFormatter(this.lastestData.co2) + "ppm"
      }, {
        icon: require("../../assets/光照强度.png"),
        name: "光照强度",
        value: this.nullFormatter(this.lastestData.lightIntensity) + "lux"
      }];
    },
    options() {
      let plotList = JSON.parse(window.localStorage.getItem('plotList'));
      plotList.forEach(el => {
        el.value = el.id;
        el.label = el.name;
      });
      return plotList;
    }
  },
  methods: {
    // 关闭弹窗前触发
    handleClose() {},
    // 打开弹窗
    open(number, plotId) {
      this.dialogVisible = true;
      this.number = number;
      this.plotId = plotId;
      this.value1 = parseInt(plotId);
      this.getData(number);
      this.getWeatherTrendData(number);
    },
    async selectChange1(e) {
      console.log(e, "eeee");
      // 根据地块获取这个地块下的环境监测设备
      let {
        data,
        code
      } = await this.$api.getPlotInfo(e);
      if (code == '200') {
        this.number = data.greenhouseVoList[0].number;
        // 获取环境监测设备的历史数据
        this.getWeatherTrendData(data.greenhouseVoList[0].number);
        // 获取最新实时数据
        this.getData(data.greenhouseVoList[0].number);
      }
      console.log(data, '地块信息');
    },
    selectChange2(e) {
      if (e == '24') {
        this.search_data.queryBeginTime = dayjs().subtract(24, "hour").format("YYYY-MM-DD") + " 00:00:00";
      }
      if (e == '7') {
        this.search_data.queryBeginTime = dayjs().subtract(7, "day").format("YYYY-MM-DD") + " 00:00:00";
      }
      if (e == '3') {
        this.search_data.queryBeginTime = dayjs().subtract(3, "day").format("YYYY-MM-DD") + " 00:00:00";
      }
      this.getWeatherTrendData(this.number);
    },
    // 打开时触发
    openChange() {
      // this.initChart();
    },
    // 关闭dialog
    closeDialog() {
      this.dialogVisible = false;
    },
    // 获取环境监测数据
    async getData(number) {
      let {
        data,
        code
      } = await this.$api.getLatestData(number);
      if (code == "200") {
        this.lastestData = data;
      }
      console.log(data, "环境监测数据");
    },
    // 获取气象站温度趋势数据
    async getWeatherTrendData(number) {
      let params = {
        number,
        ...this.search_data,
        pageSize: '10000'
      };
      let {
        rows,
        code
      } = await this.$api.getGreenhouseListData(params);
      if (code == "200") {
        this.listData = rows;
        let xData = this.getChartsData(rows, "createTime");
        let airTempData = this.getChartsData(rows, "airTemperature");
        let airHumData = this.getChartsData(rows, "airHumidity");
        let co2Data = this.getChartsData(rows, "co2");
        let lightData = this.getChartsData(rows, "lightIntensity");
        let soilTempData = this.getChartsData(rows, "soilTemperature");
        let soilHumData = this.getChartsData(rows, "soilHumidity");
        this.initChart(0, xData, airTempData, ["空气温度"]);
        this.initChart(1, xData, airHumData, ["空气湿度"]);
        this.initChart(2, xData, co2Data, ["二氧化碳浓度"]);
        this.initChart(3, xData, lightData, ["光照强度"]);
        this.initChart(4, xData, soilTempData, ["土壤温度"]);
        this.initChart(5, xData, soilHumData, ["土壤湿度"]);
      }
      console.log(rows, "气象站历史数据");
    },
    // 获取不同字段，组成数组
    getChartsData(array, prop) {
      let arr = [];
      for (let i = 0; i < array.length; i++) {
        arr.push(array[i][prop]);
      }
      return arr;
    },
    nullFormatter(val) {
      if (val == null || val == undefined || val == "") {
        return "--";
      } else {
        return val;
      }
    },
    // initChart() {
    //   this.initAirTempChart();
    //   this.initAirHumChart();
    //   this.initCo2Chart();
    //   this.initLightChart();
    //   this.initSoilTempChart();
    //   this.initSoilHumChart();
    // },
    initChart(index, xData, yData, legendData) {
      console.log(index, xData, yData, legendData, "this.$refs.echarts");
      let airTempDom = this.$refs.airTemp;
      let airHumDom = this.$refs.airHum;
      let co2Dom = this.$refs.co2;
      let lightDom = this.$refs.light;
      let soilTempDom = this.$refs.soilTemp;
      let soilHumDom = this.$refs.soilHum;
      var chartDom = airTempDom;
      if (index == 0) chartDom = airTempDom;
      if (index == 1) chartDom = airHumDom;
      if (index == 2) chartDom = co2Dom;
      if (index == 3) chartDom = lightDom;
      if (index == 4) chartDom = soilTempDom;
      if (index == 5) chartDom = soilHumDom;
      console.log(chartDom, "chartDom");
      var myChart = this.$echarts.init(chartDom);
      // 定义颜色
      const color = "#19E3B4";

      // 设置阴影渐变
      const areaStyle = {
        normal: {
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: color
          }, {
            offset: 1,
            color: "rgba(25, 227, 180, 0)"
          }])
        }
      };

      // 配置项
      const option = {
        // 设置曲线的颜色
        color: ["#19E3B4"],
        grid: {
          top: "20%",
          // 顶部留白
          left: "10%",
          // 左侧留白
          right: "10%",
          // 右侧留白
          bottom: "20%" // 底部留白
        },

        legend: {
          top: 10,
          data: legendData,
          textStyle: {
            color: "#fff",
            // 设置文字颜色为白色
            fontSize: 9 // 设置文字大小为7px
          }
        },

        xAxis: {
          type: "category",
          data: xData
        },
        yAxis: {
          type: "value"
        },
        // 设置阴影渐变
        series: [{
          name: "温度",
          type: "line",
          data: yData,
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#19E3B4"
              }, {
                offset: 1,
                color: "rgba(25, 227, 180, 0)"
              }])
            }
          }
        }]
      };
      option && myChart.setOption(option);
    },
    // 空气温度chart
    initAirTempChart() {
      var chartDom = this.$refs.airTemp;
      var myChart = this.$echarts.init(chartDom);
      const option = this.chartsOption;
      option && myChart.setOption(option);
    },
    //空气湿度chart
    initAirHumChart() {
      var chartDom = this.$refs.airHum;
      var myChart = this.$echarts.init(chartDom);
      let option = this.chartsOption;
      option.series[0].name = "湿度";
      option.legend.data = ["湿度"];
      option && myChart.setOption(option);
    },
    initCo2Chart() {
      var chartDom = this.$refs.co2;
      var myChart = this.$echarts.init(chartDom);
      let option = this.chartsOption;
      option.series[0].name = "浓度";
      option.legend.data = ["浓度"];
      option && myChart.setOption(option);
    },
    initLightChart() {
      var chartDom = this.$refs.light;
      var myChart = this.$echarts.init(chartDom);
      let option = this.chartsOption;
      option.series[0].name = "光照强度";
      option.legend.data = ["光照强度"];
      option && myChart.setOption(option);
    },
    initSoilTempChart() {
      var chartDom = this.$refs.soilTemp;
      var myChart = this.$echarts.init(chartDom);
      let option = this.chartsOption;
      option.series[0].name = "温度";
      option.legend.data = ["温度"];
      option && myChart.setOption(option);
    },
    initSoilHumChart() {
      var chartDom = this.$refs.soilHum;
      var myChart = this.$echarts.init(chartDom);
      let option = this.chartsOption;
      option.series[0].name = "湿度";
      option.legend.data = ["湿度"];
      option && myChart.setOption(option);
    }
  }
};